<div [formGroup]="form" [class]="class">
  <mat-form-field class="bg-white">
    <mat-label>{{label}}</mat-label>
    <input matInput [formControlName]="name" [placeholder]="placeholder" type="time" [step]="2">
    <mat-icon *ngIf="icon" matPrefix class="text-700 material-symbols-outlined">{{icon}}</mat-icon>
    <app-button matSuffix (click)="openGetTimeDialog()" icon="schedule" classButton="text-700" />
  </mat-form-field>
  <mat-error *ngIf="hasError()" class="text-xs">{{error()}}</mat-error>
  <mat-hint *ngIf="hint" class="text-xs text-600">{{hint}}</mat-hint>
</div>
